@if (name$ | async; as name) {
  {{ name }}
}
